export const handleKeyboardClick = (callback) => (e) => {
  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    callback();
  }
};
